<div class="relative inline-block">
  <!-- Botón u otro contenido -->
  <div
    class="inline-block"
    tabindex="0"
    [attr.aria-label]="ariaLabel"
    (mouseenter)="showTooltip()"
    (mouseleave)="hideTooltip()"
    (focus)="showTooltip()"
    (blur)="hideTooltip()"
  >
    <ng-content select="[contentAction]"></ng-content>
  </div>

  <!-- Shadow Arrow (separado del tooltip real) -->
  <div
    *ngIf="isVisible"
    class="absolute top-full right-[4px] mt-2 z-40"
    style="transform: translateY(-100%); filter: blur(3px); opacity: 0.15"
  >
    <div
      class="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[8px]"
      style="border-bottom-color: black"
    ></div>
  </div>

  <!-- Tooltip + arrow -->
  <div
    *ngIf="isVisible"
    class="absolute top-full -right-7 transform translate-x-0 mt-[7px] bg-white text-sm rounded-lg py-5 px-5 shadow-2xl z-50 transition-opacity duration-200 w-[272px]"
  >
    <div class="flex flex-col">
      <ui-paragraph
        *ngIf="title?.length"
        text-color="neutrals-900"
        font-weight="bold"
        mobile-type="p12"
        type="p14"
        [content]="title"
        class="mb-2"
      />
      <ui-paragraph
        *ngIf="content?.length"
        text-color="neutrals-900"
        font-weight="regular"
        mobile-type="p10"
        type="p12"
        [content]="content"
      />
      <ng-content select="[contentTooltip]"></ng-content>
    </div>

    <!-- Tooltip Arrow (real) -->
    <div
      class="absolute top-0 right-8 w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[8px] border-b-white"
      style="transform: translateY(-100%)"
    ></div>
  </div>
</div>
